import { selectSelectionRect, useMindmapStore } from '../../store';

/** The dotted box drawn while Shift-dragging on the pane (renderer coordinates, not zoomed). */
export const SelectionBox = () => {
  const rect = useMindmapStore(selectSelectionRect);
  if (!rect) return null;
  return (
    <div
      className="cm-selection"
      style={{ width: rect.width, height: rect.height, transform: `translate(${rect.x}px, ${rect.y}px)` }}
    />
  );
};
